import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { AjaxBasics } from '@xt/client/helpers'

import type { ClickEvent } from '@xt/client/types/home.d'

@Observer
@Component
export class MixinsHomeClick extends Vue {
  get __isH5() {
    return this.$store.$global.platform === 'Mobile'
  }

  // PC | H5 首页公共点击跳转处理
  onClickEvent(eventConfig: ClickEvent) {
    const now = this.$ajax.serviceDate()

    switch (eventConfig.type) {
      case 'toast':
        if (this.__isH5) {
          this.$toast(eventConfig.msg)
        } else {
          this.$message.info(eventConfig.msg)
        }
        break
      case 'jump-internal':
      case 'jump-internal-date':
        if (eventConfig.type === 'jump-internal-date') {
          if (now.isBefore(eventConfig.date)) {
            console.warn(
              `阻止点击事件! 跳转类型${eventConfig.date}, 点击时间: ${this.formatterTemplateDate(now)}, 配置可点击时间: ${this.formatterDate(eventConfig.date)}`
            )
            break
          }
        }

        if (this.__isH5) {
          this.$router.push({ path: eventConfig.url })
        } else {
          if (eventConfig.blank) {
            window.open(new URL(eventConfig.url, location.origin), '_blank')
          } else {
            this.$router.push({ path: eventConfig.url })
          }
        }
        break
      case 'jump-external':
      case 'jump-external-date':
        if (eventConfig.type === 'jump-external-date') {
          if (now.isBefore(eventConfig.date)) {
            console.warn(
              `阻止点击事件! 跳转类型${eventConfig.date}, 点击时间: ${this.formatterTemplateDate(now)}, 配置可点击时间: ${this.formatterDate(eventConfig.date)}`
            )
            break
          }
        }

        window.open(eventConfig.url, '_blank')
        break
      case 'none':
        break
    }
  }
}
